import PhoneNumber from 'awesome-phonenumber'

import translateFr from './translate_fr.json'


/**
 * Generate a unique id
 * @returns {String} The unique id
 */
export const generateId = () => Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)


/**
 * Verify the equality
 * @param {*} equality - Verify that the equality is true
 * @param {String} message - The error message if the equality is falsy
 */
export const assert = (equality, message) => {
  if (!equality) {
    throw new Error(message)
  }
}


/**
 * Validate an email
 * @param {String} value - The email
 * @returns {Boolean} True if the email is valid
 */
export const validateEmail = value => !/\S+@\S+\.\S+/.test(value)


/**
 * Validate a phone number
 * @param {String} phone - The phone number
 * @returns {String} Return the valid phone number. Return false if the phone number is invalid
 */
export const validatePhone = (phone) => {
  const pn = new PhoneNumber(phone, 'FR')

  if (!pn.isValid()) {
    return false
  }

  return pn.getNumber()
}


/**
 * Create a CSV File
 * @param {Array<String>} header - Header
 * @param {Array<*>} rows - Rows
 * @returns {String} The CSV File
 */
export const createCSV = (header, rows, title = 'exports') => {
  const stringify = text => (text || '').replace(/[\n;]/gi, ' ')
  const csv = `data:text/csv;charset=utf-8,\uFEFF${[header.map(stringify).join(';')].concat(rows.map(r => r.map(stringify).join(';')).join('\n')).join('\n')}`
  const encodedUri = encodeURI(csv)
  const link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  link.setAttribute('download', `${title}.csv`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}


/**
 * Get amount infos based on wallets array
 * @param {*} user - The user with wallets array
 * @returns {*} The amount object info
 */
export const getAmountInfos = (user) => {
  const result = {
    totalAmount: 0,
    currentAmount: 0,
    lastExpirationDate: null,
    firstExpirationDate: null,
  }

  if (user && Array.isArray(user.wallets)) {
    user.wallets.forEach((balance) => {
      result.totalAmount += balance.initial_amount
      result.currentAmount += balance.available_amount

      if (balance.expires_at) {
        const expiresTime = balance.expires_at.getTime()

        if (!result.lastExpirationDate || (result.lastExpirationDate < expiresTime)) {
          result.lastExpirationDate = expiresTime
        }

        if (!result.firstExpirationDate || (result.firstExpirationDate > expiresTime)) {
          result.firstExpirationDate = expiresTime
        }
      }
    })
  }

  if (result.lastExpirationDate) {
    result.lastExpirationDate = new Date(result.lastExpirationDate)
  }

  if (result.firstExpirationDate) {
    result.firstExpirationDate = new Date(result.firstExpirationDate)
  }

  return result
}

/**
 * Translate a value
 * @param key - The key to translate
 */
export const translate = (key) => {
  const value = translateFr[key]

  return value || key
}

export const printCanvas = (canvas, options = {}) => {
  const dataUrl = canvas.toDataURL()
  const { title = '' } = options
  const content = `
  <!DOCTYPE html>
    <head>
      <title>${title}</title>
    </head>
    <body>
      <img src="${dataUrl}" style="height:600px;max-height:100vh;max-width:100vw;" onload="printWindow()" />

      <script>
        function printWindow() {
          window.stop();
          window.focus();
          window.print();
        }
      </script>
    </body>
  </html>
  `

  const printWin = window.open()
  printWin.document.open()
  printWin.document.write(content)
}
